import React from 'react';
import CostDashboard from './CostDashboard';
import FoodPriceTracker from './FoodPriceTracker';
import InventoryTrends from './InventoryTrends';
import Invoices from './Invoices';

// Inventory hub. Hosts purchasing / supply-analysis surfaces:
//   - Dashboard       (default — operator's morning radar; moved here from
//                      OPERATIONS in the dashboard restructure commit so it
//                      lives where the rest of the purchasing flow lives)
//   - Price Tracker
//   - Inventory Trends
//   - Invoices        (Browse + Reports tabs; Reports hosts Period summary,
//                      Single item history, Top spend, Top movers)
//
// No in-page underline tab strip. The sidebar's INVENTORY group renders all
// sub-items as direct nav links, so an in-page tab strip would just duplicate
// the same control. See DESIGN_SYSTEM.md §Sidebar groups always expanded.
//
// Invoices receives navConfig + onConsumeNavConfig from App.js so the
// "Open invoices →" link from the Inventory Trends compact strip can pre-fill
// Invoices' period state to whatever the operator was viewing. One-shot
// consumption — Invoices clears it on mount so re-navigating doesn't
// re-trigger.

export default function Inventory({ companyId, initialTab = 'dashboard', navConfig, onConsumeNavConfig }) {
  const tab = initialTab;

  switch (tab) {
    case 'dashboard':
      return <CostDashboard companyId={companyId} />;
    case 'pricetracker':
      return <FoodPriceTracker companyId={companyId} />;
    case 'trends':
      return <InventoryTrends companyId={companyId} />;
    case 'invoices':
      return <Invoices companyId={companyId} navConfig={navConfig} onConsumeNavConfig={onConsumeNavConfig} />;
    default:
      return null;
  }
}
